import ProductListLayout, { ProductListLayoutProps } from '@/features/products/list/layout';

export type { ProductListLayoutProps };

export default ProductListLayout;
